module.exports = __webpack_public_path__ + "img/icon-left-arrow.75b9c426.svg";